module.exports = __webpack_public_path__ + "static/media/icon-close.28c57ee9.svg";